import Password from './Password';

Password.displayName = 'Form.Password';

export default Password;
